import Countly from "countly-sdk-web";
import { getAllSources, getIsOnpremise, getPlatform, isLoggedInUser, isWebView } from "..";
import getEnv from "../getEnv";
import isMobile from "../isMobile";
import constants from "../constants";
import getConfig from "next/config";
import { isEmpty } from "lodash";
import { MIXPANEL_EVENTS } from "../mixpanelEvents";
var PROD = "production";
var isProduction = getEnv("NEXT_PUBLIC_APP_ENV") === PROD;
function getCountlyFormattedUserProperties(userData) {
  var _getConfig, _userData$details, _userData$details2, _userData$details3, _userData$details4, _userData$details5, _userData$details6, _userData$details7;
  var sources = getAllSources(userData);
  var sourceIds = sources.map(function (source) {
    return source.uuid;
  });
  var PLATFORMS = constants.PLATFORMS;
  var platform = Object.keys(PLATFORMS).find(function (p) {
    return PLATFORMS[p] === getPlatform();
  });
  var appVersion = ((_getConfig = getConfig()) === null || _getConfig === void 0 || (_getConfig = _getConfig.publicRuntimeConfig) === null || _getConfig === void 0 ? void 0 : _getConfig.version) || "unknown";
  return {
    name: userData === null || userData === void 0 || (_userData$details = userData.details) === null || _userData$details === void 0 ? void 0 : _userData$details.name,
    username: userData === null || userData === void 0 || (_userData$details2 = userData.details) === null || _userData$details2 === void 0 ? void 0 : _userData$details2.email,
    email: userData === null || userData === void 0 || (_userData$details3 = userData.details) === null || _userData$details3 === void 0 ? void 0 : _userData$details3.email,
    app_version: appVersion,
    custom: {
      sourceIds: sourceIds,
      isMobileApp: isWebView(),
      platform: platform,
      sourceIdentifier: (userData === null || userData === void 0 || (_userData$details4 = userData.details) === null || _userData$details4 === void 0 ? void 0 : _userData$details4.source_identifier) || "personal_user",
      country: userData === null || userData === void 0 || (_userData$details5 = userData.details) === null || _userData$details5 === void 0 ? void 0 : _userData$details5.country,
      vertical: userData === null || userData === void 0 || (_userData$details6 = userData.details) === null || _userData$details6 === void 0 ? void 0 : _userData$details6.vertical,
      clientName: userData === null || userData === void 0 || (_userData$details7 = userData.details) === null || _userData$details7 === void 0 ? void 0 : _userData$details7.client_name,
      appVersion: appVersion,
      deviceName: getEnv("NEXT_PUBLIC_DEVICE_NAME") || "unknown"
    }
  };
}
function initializeCountly() {
  var _window;
  var isOnPremise = getIsOnpremise();
  var APP_KEY = getEnv("NEXT_PUBLIC_COUNTLY_APP_KEY");
  var COUNTLY_URL = "http://".concat((_window = window) === null || _window === void 0 ? void 0 : _window.location.hostname, ":").concat(getEnv("NEXT_PUBLIC_COUNTLY_PORT"));

  // disabled countly for cloud builds
  if (!isOnPremise || !APP_KEY) {
    return function () {};
  }
  Countly.init({
    // server credentials
    app_key: APP_KEY,
    url: COUNTLY_URL,
    debug: !isProduction
  });
  Countly.track_sessions();
  Countly.track_errors();
  Countly.q.push(["disable_heatmaps"]);
  return function (userData) {
    var _userData$details8;
    var deviceId = (userData === null || userData === void 0 ? void 0 : userData.username) || (userData === null || userData === void 0 || (_userData$details8 = userData.details) === null || _userData$details8 === void 0 ? void 0 : _userData$details8.email) || "";
    if (isMobile()) {
      deviceId = "".concat(deviceId, "_mobile");
    }
    Countly.set_id(deviceId);
    var userProperties = getCountlyFormattedUserProperties(userData);
    trackCountlyUserProfile(userProperties);
    // if userData has the loginSource then add to countlyEvent
    if (!isEmpty(userData === null || userData === void 0 ? void 0 : userData.loginSource)) {
      trackCountlyEvent({
        key: MIXPANEL_EVENTS.LOGIN_SOURCE,
        segs: {
          loginSource: userData === null || userData === void 0 ? void 0 : userData.loginSource
        }
      });
    }
  };
}
var trackCountlyEvent = function trackCountlyEvent(_ref) {
  var key = _ref.key,
    dur = _ref.dur,
    segs = _ref.segs;
  Countly.q.push(["add_event", {
    key: key,
    dur: dur,
    segmentation: segs
  }]);
};
function trackCountlyUserProfile(userProfile) {
  Countly.q.push(["user_details", userProfile]);
}

/**
 * Track a page view event in Mixpanel with a page name parameter.
 * Kept for later use
 * @param pageName - The name of the page to track
 */
var trackCountlyPageView = function trackCountlyPageView(pageName, segments) {
  var isOnPremise = getIsOnpremise();
  if (!isOnPremise || !isLoggedInUser()) {
    return;
  }
  Countly.q.push(["track_pageview", pageName, [], segments]);
};
export { initializeCountly, trackCountlyPageView, trackCountlyEvent };